// extracted by mini-css-extract-plugin
export default {"container":"alo_container__tGaCV","alo_frame":"alo_alo_frame__UBcQ6"};